import { colors } from '@ui/colors'
import { ChecklistItemState } from './types'

type StateToColor = Record<ChecklistItemState, string>
type StateToNumber = Record<ChecklistItemState, number>

export const textColor: StateToColor = {
  upcoming: colors.text25,
  todo: colors.blue[600],
  done: colors.text,
  locked: colors.text50,

  'radio-positive': colors.green[600],
  'radio-neutral': colors.text,
  'radio-negative': colors.text25,
}

export const pointColorBack: StateToColor = {
  upcoming: colors.white,
  todo: colors.blue[600],
  done: colors.text,
  locked: colors.text50,

  'radio-positive': colors.green[600],
  'radio-neutral': colors.white,
  'radio-negative': colors.white,
}

export const pointColorFront: StateToColor = {
  upcoming: colors.text25,
  todo: colors.white,
  done: colors.white,
  locked: colors.text50,

  'radio-positive': colors.green[600],
  'radio-neutral': colors.text,
  'radio-negative': colors.text25,
}

export const pointBorderColor: StateToColor = {
  upcoming: colors.text25,
  todo: colors.text0,
  done: colors.text0,
  locked: colors.text50,

  'radio-positive': colors.green[600],
  'radio-neutral': colors.text,
  'radio-negative': colors.text25,
}

export const lineColor: StateToColor = {
  upcoming: colors.text25,
  todo: colors.text25,
  done: colors.text,
  locked: colors.text25,

  'radio-positive': colors.green[600],
  'radio-neutral': colors.text,
  'radio-negative': colors.text25,
}

export const pointBorderWidth: StateToNumber = {
  upcoming: 3,
  todo: 3,
  done: 0,
  locked: 0,

  'radio-positive': 0,
  'radio-neutral': 3,
  'radio-negative': 3,
}

export const getColorsArray = (colors: StateToColor) => Object.values(colors)
export const getNumbersArray = (numbers: StateToNumber) =>
  Object.values(numbers)

export const animationConfig = {
  overshootClamping: false,
  mass: 1,
  stiffness: 100,
  damping: 15,
}
